/** Единая проверка демо-режима SPA.
 *  Возвращает true если:
 *  1. Установлена кука demo_notify_session (прошли через /notify/TOKEN), или
 *  2. Страница открыта по пути /demo-notify/* (прямой переход или reload).
 */
export function isDemoNotify(): boolean {
  if (typeof document === 'undefined') return false;
  const hasCookie = document.cookie
    .split(';')
    .some((c) => c.trim().startsWith('demo_notify_session='));
  const hasPath =
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/demo-notify');
  return hasCookie || hasPath;
}
